import { portalApiClient } from '@/platform/http'

export const getOrganizations = async () => {
  try {
    const data = await portalApiClient.get_organizations_v2_auth_organizations_get()
    return { error: null, data }
  } catch (e) {
    const error = e instanceof Error ? e : new Error('Failed to load organizations', { cause: e })
    return { error, data: null }
  }
}

const organizationsRepository = { getOrganizations }
export default organizationsRepository
